<script>
import axios from 'axios';
import {InboundOrderPath} from '@/path.js';
import Swal from 'sweetalert2';

    export default {
        props : ['selectedProduction','settingStatus','type'],
        data(){
            return {
                data : [],
                currentPage : 1,
                search : '',
                base_url : process.env.VUE_APP_API_BACKEND_URL,
                fields : ['batch_code','item','qty','best_before_date','actions'],
                fields_two : ['batch_code','item','qty','qty_produced_or_received','best_before_date'],
                filter : '',
                key : 1,
                batch_code : null
            }
        },
        mounted(){
            this.$nextTick(() => {
                this.getBatches();
            })
        },
        watch : {
          data : {
            deep : true,
            handler(){
                this.key += 1;
            }
          }
        },
        methods : {
            async showConfirmation() {
                const { value: confirmed } = await Swal.fire({
                title: 'Are you sure?',
                text: 'Once Marked as completed cannot be reverted',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, Mark As Received'
                });
                
                return confirmed;
            },
            async saveStatus(){
                try {
                    let result = await this.showConfirmation();
                    if(!result){
                        return;
                    }
                    let res = await axios.post(this.base_url + InboundOrderPath.UpdateStatus,{
                        order_data : this.data.map(m => {return {'id' : m.id,'qty_final' : m.qty_final}}),
                        status : this.selectedProduction.status == 'pending' ? 'completed' : (this.selectedProduction.status == 'in_progress' ? 'completed' : 'pending'),                        
                        type : this.type
                    });
                    if(res.data.status){
                        Swal.fire('Updated Successfully');
                        this.$emit('reload');
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            async saveStatusMain(v){
                try {
                    let res = await axios.post(this.base_url + InboundOrderPath.EDIT_TRANSFER_BATCH_V2,{
                        id : v.id,
                        qty : v.qty                        
                    });
                    if(res.data.status){
                        Swal.fire("Success","","success");                        
                    }else{
                        Swal.fire(res.data.message,"","error");
                    }
                } catch (error) {
                    console.log(error);
                    Swal.fire("Failed","","error");
                }
            },
            async deleteStatusMain(v){
                try {
                    let res = await axios.post(this.base_url + InboundOrderPath.REMOVE_TRANSFER_ITEM,{
                        id : v.id
                    });
                    if(res.data.status){
                        Swal.fire("Success","","success");
                    }else{
                        Swal.fire(res.data.message,"","error");
                    }
                } catch (error) {
                    console.log(error);
                    Swal.fire("Failed","","error");
                }
            },
            async processBarcode() {      
                let index = this.data.findIndex(f => f.batch_code == this.batch_code);
                console.log(index);
                if(index !== -1){                    
                    if(this.data[index].qty > this.data[index].qty_final){
                        this.data[index].qty_final += 1;
                    }else{
                        Swal.fire("Qty Limit Reached","","error");
                    }
                }else{
                    Swal.fire("Batch Code not found","","error");
                }
                this.batch_code = '';
                this.$refs.barcodeInput.value = '';
            },     
            rowClass(item){
                if(item.qty == item.qty_final){
                    return 'table-success';
                }else if(item.qty_final != 0 && item.qty > item.qty_final){
                    return 'table-warning';
                }
            },    
            async getBatches(){
                try {
                    let res = await axios.get(this.base_url + InboundOrderPath.GET_BATCH_DETAILS,{
                        params : {
                            date : this.selectedProduction.production_date,
                            status : this.selectedProduction.status,
                            warehouse : this.selectedProduction.warehouse_id,
                            location : this.selectedProduction.location_id,
                            page : this.currentPage,
                            unique_batch_id : this.selectedProduction.unique_batch_id,
                            type : this.type
                        }
                    });
                    if(res.data.status){
                        this.data = res.data.data.map(m => {
                            if(m.qty_final == 0 && this.selectedProduction.status == 'pending'){
                                m.qty_final = m.qty;
                            }
                            return m;
                        });
                    }                    
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
</script>

<template>
    <div>
        <div class="float-right">
            <label>Search</label>
            <b-input v-model="filter"></b-input>
        </div>        
        <div>
            <input
                    type="text"
                    v-model="batch_code"
                    @keyup.enter="processBarcode"
                    ref="barcodeInput"
                    placeholder="Scan a barcode"
                    class="form-control mb-4"
                />
        </div>
        <b-table
            :key="key"
            :items="data"
            :fields="settingStatus == true ? fields_two : fields"
            responsive="sm"
            :per-page="20"
            :filter="filter"
            :current-page="currentPage"     
            :tbody-tr-class="rowClass"       
        >
            <template v-slot:cell(item)="row">
                {{ row.item.gravy_id != null ? row.item.gravy.name : row.item.packaging.name }}                
            </template>
            <template v-slot:cell(qty_produced_or_received)="row">
                <b-input v-model="row.item.qty_final" type="number" :max="row.item.qty" :value="row.item.qty"></b-input>
                <!-- {{ row.item.qty_final }}
                <b-button class="ml-2" size="sm" @click="(() => {row.item.qty_final -= 1; this.key+=1})"><i class="fa fa-minus"></i></b-button> -->
            </template>
            <template v-slot:cell(qty)="row" v-if="settingStatus == false">
                <!-- <b-input v-model="row.item.qty" type="number" :value="row.item.qty" @change="saveStatusMain(row.item)"></b-input> -->
                <p v-if="row.item.status == 'pending'">{{ row.item.qty }}</p>
                <p v-else>{{ row.item.qty_final }}</p>
            </template>
            <template v-slot:cell(actions)="row"  v-if="settingStatus == false">
                <b-button variant="danger" @click="deleteStatusMain(row.item)" v-if="row.item.status == 'pending'"><i class="fa fa-trash"></i></b-button>
            </template>
        </b-table>
        <div class="row">
            <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">                                                
                        <b-pagination :key="data.key" v-model="currentPage" :total-rows="data.length" :per-page="20"></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
        <b-button variant="success" v-if="settingStatus == true" @click="saveStatus">Save</b-button>        
    </div>
</template>

<style>
    
</style>